var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"loadModal"}},[_c('div',[_c('b-row',[_c('b-col',{staticClass:"d-flex align-items-center justify-content-center"},[_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin","font-scale":"4"}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }